import {
  getGlobalInvoices,
  downloadGlobalInvoicesList
} from 'src/services/transactionsService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import { SnackBarVariants } from 'src/utils/constants/common';
import { toMexicoCityInstant } from 'src/utils/momentLocalTimezone';
import { selectGlobalInvoicesQueryOptions } from '../selectors/globalInvoiceSelectors';
import { showMessage } from './snackBarActions';

export const LOAD_GLOBAL_INVOICES = asyncActionCreator('LOAD_GLOBAL_INVOICES');
export const DOWNLOAD_GLOBAL_INVOICES_LIST = asyncActionCreator(
  'DOWNLOAD_GLOBAL_INVOICES_LIST'
);
export const SAVE_GLOBAL_INVOICES_OPTIONS = 'SAVE_GLOBAL_INVOICES_OPTIONS';
export const CLEAR_GLOBAL_INVOICES = 'CLEAR_GLOBAL_INVOICES';

function getRequestOptions(getState) {
  const queryOpts = selectGlobalInvoicesQueryOptions(getState());
  const reqOptions = {};

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (queryOpts.search) {
    reqOptions.search = queryOpts.search;
  }
  if (queryOpts.category) {
    reqOptions.category = queryOpts.category;
  }
  if (queryOpts.paymentMethod) {
    reqOptions.paymentMethod = queryOpts.paymentMethod;
  }
  if (queryOpts.afterDate) {
    reqOptions.afterDate = toMexicoCityInstant(queryOpts.afterDate)
      .startOf('day')
      .toISOString();
  }
  if (queryOpts.beforeDate) {
    reqOptions.beforeDate = toMexicoCityInstant(queryOpts.beforeDate)
      .endOf('day')
      .toISOString();
  }
  if (queryOpts.tab) {
    reqOptions.tab = queryOpts.tab;
  }

  return reqOptions;
}

export const loadGlobalInvoices = options => async (dispatch, getState) => {
  try {
    dispatch({ type: LOAD_GLOBAL_INVOICES.start });
    dispatch({ type: SAVE_GLOBAL_INVOICES_OPTIONS, options });

    const reqOptions = getRequestOptions(getState);
    reqOptions.limit = selectGlobalInvoicesQueryOptions(getState()).limit;

    const response = await getGlobalInvoices(reqOptions);

    return dispatch({
      type: LOAD_GLOBAL_INVOICES.success,
      ...response
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_GLOBAL_INVOICES.failure });
  }
};

export const downloadGlobalInvoicesListAction = () => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: DOWNLOAD_GLOBAL_INVOICES_LIST.start });

    const reqOptions = getRequestOptions(getState);
    await downloadGlobalInvoicesList(reqOptions);

    return dispatch({ type: DOWNLOAD_GLOBAL_INVOICES_LIST.success });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: DOWNLOAD_GLOBAL_INVOICES_LIST.failure });
  }
};

export const clearGlobalInvoices = () => dispatch => {
  dispatch({ type: CLEAR_GLOBAL_INVOICES });
};
